// extracted by mini-css-extract-plugin
export default {"items":"CheckboxGroup_items__hj11C","checkBox":"CheckboxGroup_checkBox__C+B+S"};